var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mount-visualisation" },
    [
      _c("b-overlay", { attrs: { show: _vm.loading && _vm.board !== null } }, [
        _vm.board
          ? _c("img", {
              staticClass: "mb-4",
              attrs: { id: "viz-image", src: _vm.url },
              on: {
                load: function ($event) {
                  _vm.loading = false
                },
              },
            })
          : _vm._e(),
      ]),
      _c(
        "b-row",
        { attrs: { "align-h": "center" } },
        [
          _c("b-col", { attrs: { sm: "8" } }, [
            _c("picture", [
              _c("source", {
                attrs: {
                  srcset: require("@/img/site/larson-juhl-logo.jpg?format=webp"),
                  type: "image/webp",
                },
              }),
              _c("source", {
                attrs: {
                  srcset: require("@/img/site/larson-juhl-logo.jpg"),
                  type: "image/jpeg",
                },
              }),
              _c("img", {
                attrs: {
                  src: require("@/img/site/larson-juhl-logo.jpg"),
                  type: "image/jpeg",
                },
              }),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }